import React, { useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";

export default function RfmMergeTablesModal({ open, onClose, zones = [], tables = [], onMerge }) {
  const [zoneId, setZoneId] = useState(zones?.[0]?.id || "");
  const [selected, setSelected] = useState([]); // ids

  const zoneTables = useMemo(() => tables.filter((t) => t.zone === zoneId), [tables, zoneId]);

  const toggle = (id) => {
    setSelected((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  const canMerge = selected.length >= 2;

  const submit = () => {
    if (!canMerge) return;
    onMerge?.({ zoneId, tableIds: selected });
    setSelected([]);
    onClose?.();
  };

  return (
    <RfmModalBase
      open={open}
      title="Unir Mesas"
      onClose={() => { setSelected([]); onClose?.(); }}
      footer={
        <>
          <div className="ord-footer">
            <button className="ord-btn ord-btn-secondary" type="button" onClick={() => { setSelected([]); onClose?.(); }}>
              Cancelar
            </button>
            <button className="ord-btn ord-btn-primary" type="button" onClick={submit} disabled={!canMerge}>
              <i className="bi bi-plus-lg" /> Unir Mesas
            </button>
          </div>
        </>
      }
    >
      <p style={{ fontSize: "0.8rem", color: "var(--text-secondary)", marginBottom: "0.75rem" }}>
        Selecciona mesas disponibles de la misma zona.
      </p>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Zona</label>
        <select className="rfm-form-input" value={zoneId} onChange={(e) => { setZoneId(e.target.value); setSelected([]); }}>
          {zones.map((z) => <option key={z.id} value={z.id}>{z.name}</option>)}
        </select>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Mesas (selecciona 2+)</label>
        <div className="rfm-merge-select">
          {zoneTables.map((t) => {
            const disabled = t.status !== "available" || (t.mergedWith && t.mergedWith.length > 0);
            const isSel = selected.includes(t.id);
            return (
              <div
                key={t.id}
                className={[
                  "rfm-merge-option",
                  disabled ? "disabled" : "",
                  isSel ? "selected" : "",
                ].join(" ")}
                onClick={() => { if (!disabled) toggle(t.id); }}
              >
                Mesa {t.number}
              </div>
            );
          })}
        </div>
      </div>
    </RfmModalBase>
  );
}
